
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 10.111c0 6.611-5.571 10.389-6.5 10.389-.929 0-6.5-3.778-6.5-10.389C5.5 6.46 8.41 3.5 12 3.5s6.5 2.96 6.5 6.611z","stroke":"#fff","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"12","cy":"10.222","r":"2","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    